<template>
  <section class="ppt-upgrade">
    <header>
      <h1 class="page-header">Upgrade</h1>
    </header>
    <errors-alert
      v-bind:errors="errorsFromBackend"
      v-on:clear="clearAlert()"
    />
    <section class="alert alert-info">
      <p>You have previously purchased the basic version of Six Plus Hold’em for $25. If you would like to upgrade to the premium version for an additional $50, fill out and submit the form below.</p>
      <p>If you have any questions, don't hesitate to reach out: <a href="mailto:contact@sixplusholdem.com">contact@sixplusholdem.com</a>.</p>
    </section>
    <pricing-table />
    <hr>
    <section class="form-group">
      <label>
        Credit card number
        <card-number
          ref="cardNumber"
          class="stripe-element card-number form-control"
          v-bind:stripe="stripeConsumerKey"
          v-bind:options="options"
          v-on:change="number = $event.complete"
        />
      </label>
    </section>
    <section class="form-group">
      <label>
        Expiration date
        <card-expiry
          ref="cardExpiry"
          class="stripe-element card-expiry form-control"
          v-bind:stripe="stripeConsumerKey"
          v-bind:options="options"
          v-on:change="expiry = $event.complete"
        />
      </label>
    </section>
    <section class="form-group">
      <label>
        CVC
        <card-cvc
          ref="cardCvc"
          class="stripe-element card-cvc form-control"
          v-bind:stripe="stripeConsumerKey"
          v-bind:options="options"
          v-on:change="cvc = $event.complete"
        />
      </label>
    </section>
    <button
      class="pay-with-stripe btn btn-primary btn-block btn-lg"
      v-bind:disabled="!complete || upgrading"
      v-on:click="upgrade()"
    >
      {{ upgradeText }}
    </button>
  </section>
</template>

<script>
import ErrorsAlert from '@/components/utilities/errors-alert';
import PricingTable from '@/components/utilities/pricing-table';
import { CardNumber, CardExpiry, CardCvc, createToken } from 'vue-stripe-elements-plus';
import utilities from '@/services/utilities/utilities';

export default {
  name: 'ppt-upgrade',
  components: {
    'errors-alert': ErrorsAlert,
    'pricing-table': PricingTable,
    'card-number': CardNumber,
    'card-expiry': CardExpiry,
    'card-cvc': CardCvc,
  },
  data: function () {
    return {
      stripeConsumerKey: process.env.STRIPE_CONSUMER_KEY,
      options: {},
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      upgrading: false,
      errorsFromBackend: [],
    };
  },
  computed: {
    upgradeText: function () {
      if (this.upgrading) {
        return 'Upgrading...';
      }

      return 'Upgrade to the premium version for for $50';
    },
  },
  watch: {
    number: function () {
      this.update();
    },
    expiry: function () {
      this.update();
    },
    cvc: function () {
      this.update();
    },
  },
  beforeRouteLeave: function (to, from, next) {
    this.$destroy(); // because of stripe issue
    next();
  },
  methods: {
    update: function () {
      this.complete = this.number && this.expiry && this.cvc;

      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    upgrade: function () {
      let self = this;

      self.upgrading = true;
      createToken()
        .then(function (result) {
          if (result.error) {
            self.upgrading = false;
            self.errorsFromBackend.push(result.error.message);
          }

          else {
            self.$http
              .patch(`${process.env.BASE_API_URL}/user/upgrade-to-premium`, {
                token: result.token.id,
              })
              .then(function () {
                self.$store.commit('account/upgradeToPremiumVersion');
                self.upgrading = false;
                alert(`Successfully upgraded to the premium version of Six Plus Hold’em!`);
                self.$router.push({ path: '/account' });
              })
              .catch(function (e) {
                self.upgrading = false;
                utilities.general.handleNetworkError(e);
              })
            ;
          }
        })
        .catch(function (e) {
          self.upgrading = false;
          utilities.general.handleNetworkError(e);
        })
      ;
    },
    clearAlert: function () {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
    },
  },
};
</script>

<style lang="scss" scoped>
  .ppt-upgrade {
    font-size: 18px;
  }

  button {
    font-size: 18px;
  }

  .credit-card-inputs.complete {
    border: 2px solid green;
  }

  label {
    width: 100%;
  }

  .form-control {
    width: 100%;
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/upgrade.vue